module.exports = __webpack_public_path__ + "static/Hero_B_02A_copy-7d966dc49426f4c09c4fc959e8b23fb9.jpg";